/* istanbul ignore file */

import React from "react";
import { getMaandlastKeuzeTekst } from "../infra/scenario-utils";
import { ControleMaandlastOptions } from "../infra/utils";
import { Column } from "../../components/BaseTable";
import Table from "../../components/Table";

export interface ControleMaandlastTableProps {
  conclusies: string[];
  controleMaandlastKeuze: ControleMaandlastOptions | null;
}

export const ControleMaandlastTable: React.FC<ControleMaandlastTableProps> = ({
  conclusies,
  controleMaandlastKeuze,
}: ControleMaandlastTableProps) => {
  const columns: Column[] = [
    {
      header: "",
      accessor: () => [],
    },
    {
      header: `De maandlast die overblijft voor deze situatie t.o.v. de ${getMaandlastKeuzeTekst(
        controleMaandlastKeuze
      )} ?`,
      accessor: "conclusie",
      style: "font-weight: bold;",
      violation: (value: string) => value === "Overschrijdt",
    },
  ];

  return (
    <Table
      columns={columns}
      data={conclusies.map((conclusie) => ({
        conclusie,
      }))}
      rotate
    />
  );
};
